import React, {useState} from 'react';
import {Row,Col} from 'antd';
import InputField from '../../../../input-field';
import DividerBlock from '../../../../divider-block';
import i18n from '../../../../../i18n';

export default function SecondStep({ setFields, stepFields, getFieldErrors, organizationalForm, country }) {

    return (
        <>
          <DividerBlock label={i18n.t('modals.modalEditLegalEntity.divider.legalAddress')} />

          <Row>
              <Col lg={18} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                  <InputField name="legalAddressCity" label={i18n.t('modals.modalEditLegalEntityNew.fields.addressCity.title')}  value={stepFields.legalAddressCity} setValue={value => setFields({...stepFields, legalAddressCity: value})} getFieldErrors={getFieldErrors} />
              </Col>
              <Col lg={18} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                  <InputField name="legalAddress" label={i18n.t('modals.modalEditLegalEntityNew.fields.address.title')} value={stepFields.legalAddress} setValue={value => setFields({...stepFields, legalAddress: value})} getFieldErrors={getFieldErrors} />
              </Col>
              <Col lg={6} sm={24} style={{ margin: "0 0 20px 0" }}>
                  <InputField name="legalAddressPostalCode" label={i18n.t('modals.modalEditLegalEntityNew.fields.postalCode.title')} value={stepFields.legalAddressPostalCode} setValue={value => setFields({...stepFields, legalAddressPostalCode: value})} getFieldErrors={getFieldErrors} />
              </Col>
          </Row>

          <DividerBlock label={i18n.t('modals.modalEditLegalEntity.divider.regAddress')} />
            <Row>
                <Col lg={18} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                    <InputField name="regAddress" label={i18n.t('modals.modalEditLegalEntityNew.fields.address.title')} value={stepFields.regAddress} setValue={value => setFields({...stepFields, regAddress: value})} getFieldErrors={getFieldErrors} />
                </Col>
                <Col lg={6} sm={24} style={{ margin: "0 0 20px 0" }}>
                    <InputField name="regAddressPostalCode" label={i18n.t('modals.modalEditLegalEntityNew.fields.postalCode.title')} value={stepFields.regAddressPostalCode} setValue={value => setFields({...stepFields, regAddressPostalCode: value})} getFieldErrors={getFieldErrors} />
                </Col>
            </Row>

          <Row>
            { organizationalForm !== 1 &&
              <>
                  <DividerBlock label={i18n.t('modals.modalEditLegalEntity.divider.mailingAddress')} />
                  <Col lg={18} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                      <InputField name="mailingAddress" label={i18n.t('modals.modalEditLegalEntityNew.fields.address.title')} value={stepFields.mailingAddress} setValue={value => setFields({...stepFields, mailingAddress: value})} getFieldErrors={getFieldErrors} />
                  </Col>
                  <Col lg={6} sm={24} style={{ margin: "0 0 20px 0" }}>
                      <InputField name="mailingAddressPostalCode" label={i18n.t('modals.modalEditLegalEntityNew.fields.postalCode.title')} value={stepFields.mailingAddressPostalCode} setValue={value => setFields({...stepFields, mailingAddressPostalCode: value})} getFieldErrors={getFieldErrors} />
                  </Col>
                </>
            }
          </Row>
        </>
    );
}
